// extracted by mini-css-extract-plugin
module.exports = {"title":"CourseInfo_title__Js4bX"};